import { create } from "zustand";

export const EMPTY_HISTORY = {
  uid: null,
  items: [],
  cursor: null,
  hasMore: true,
  loaded: false,
  loading: false,
  // True while "Search older actions" loads every remaining page.
  loadingAll: false,
  error: false,
};

const useActionsStore = create((set) => ({
  loading: false,
  error: false,
  actionItems: [],
  outboxItems: [],
  sharedAccessList: [],
  labels: [],
  outboxLoading: false,
  outboxError: false,
  sharedAccessLoading: false,
  sharedAccessError: false,
  // Bumping this restarts the action listeners, which runs a fresh server
  // query. Used when a change was made outside this tab (e.g. by the agent).
  refreshKey: 0,
  refreshActions: () =>
    set((state) => ({
      refreshKey: state.refreshKey + 1,
    })),
  setActionItems: (data) =>
    set(() => ({
      actionItems: data,
    })),
  setLoading: (status) =>
    set(() => ({
      loading: status,
    })),
  setError: (status) =>
    set(() => ({
      error: status,
    })),
  setOutboxItems: (data) =>
    set(() => ({
      outboxItems: data,
    })),
  setOutboxLoading: (status) =>
    set(() => ({
      outboxLoading: status,
    })),
  setOutboxError: (status) =>
    set(() => ({
      outboxError: status,
    })),
  setSharedAccessList: (data) =>
    set(() => ({
      sharedAccessList: data,
    })),
  setSharedAccessLoading: (status) =>
    set(() => ({
      sharedAccessLoading: status,
    })),
  setSharedAccessError: (status) =>
    set(() => ({
      sharedAccessError: status,
    })),
  setLabels: (data) =>
    set(() => ({
      labels: data,
    })),
  // Completed actions older than the live 30 days, loaded page by page on
  // the Completed and All tabs. `uid` drops pages from another account.
  history: EMPTY_HISTORY,
  // Server count of completed actions older than the live window.
  olderCompletedCount: null,
  // The live window starts here. It is set once per account and session, so
  // the live list and the history pages split at exactly the same date.
  liveCutoff: null,
  setLiveCutoff: (liveCutoff) => set(() => ({ liveCutoff })),
  setHistory: (patch) =>
    set((state) => ({ history: { ...state.history, ...patch } })),
  resetHistory: () => set(() => ({ history: EMPTY_HISTORY, olderCompletedCount: null })),
  setOlderCompletedCount: (count) => set(() => ({ olderCompletedCount: count })),
  // Replaces history items after an edit, or drops them (null = deleted).
  replaceHistoryItems: (updates) =>
    set((state) => {
      if (!state.history.items.length) return state;
      const items = state.history.items
        .map((item) => (item.id in updates ? updates[item.id] : item))
        .filter(Boolean);
      return { history: { ...state.history, items } };
    }),
}));
export default useActionsStore;
